import jquery from 'jquery';

const MONTHLY_CLASS = 'monthly';
const YEARLY_CLASS = 'yearly';

jquery(() => {
    const togglerNode = jquery('#toggle-price-interval');
    const priceBoxNode = jquery('#price-box');

    if (!togglerNode.length || !priceBoxNode.length) {
        return;
    }


    function updatePrice() {
        const yearly = togglerNode.is(':checked');

        if (yearly) {
            priceBoxNode.addClass(YEARLY_CLASS);
            priceBoxNode.removeClass(MONTHLY_CLASS);
        } else {
            priceBoxNode.removeClass(YEARLY_CLASS);
            priceBoxNode.addClass(MONTHLY_CLASS);
        }
    }

    togglerNode.prop('disabled', false).on('change', updatePrice);
    updatePrice();
});
